module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-list', {
    class: "md-triple-line md-dense "
  }, [_c('md-list-item', {
    class: ("tournament " + _vm.state),
    on: {
      "click": _vm.onSelect
    }
  }, [_c('div', {
    staticClass: "tournament-day"
  }, [_vm._v(_vm._s(_vm.day))]), _vm._v(" "), _c('div', {
    staticClass: "md-list-item-text"
  }, [_c('span', {
    staticClass: "tournament-name"
  }, [_vm._v(_vm._s(_vm.tournament.name))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.dates))])]), _vm._v(" "), (_vm.tournament.location) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.tournament.location.name))])]) : _vm._e()]), _vm._v(" "), _c('img', {
    staticClass: "sport",
    attrs: {
      "src": _vm.icon(_vm.tournament)
    }
  })]), _vm._v(" "), _c('md-tooltip', [_vm._v(_vm._s(_vm.details))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7224c2fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/listingComponents/tournamentEntry.vue
// module id = 453
// module chunks = 1